<app-modal-generico [modelo]="modalGenerico">
    <div #mensaje class="correo-mensaje"></div>
</app-modal-generico>